<template>
  <div class="content mrv-page">

    <!-- ============================================================
         TOOLBAR CARD: Bộ lọc tìm kiếm
         ============================================================ -->
    <div class="mrv-toolbar-card row-data">
      <div class="mrv-toolbar-section mrv-toolbar-section--filter">
        <div class="mrv-card-head">
          <div>
            <p class="mrv-card-title">Bộ lọc tìm kiếm</p>
            <p class="mrv-card-subtitle">Lọc học sinh theo trạng thái, lớp/nhóm và tên.</p>
          </div>
        </div>

        <div class="mrv-filter-grid">
          <!-- Trạng thái học sinh -->
          <el-select
              v-model="searchRequest.status"
              placeholder="Trạng thái"
              clearable
              class="mrv-filter-control"
              @change="handleSearch"
          >
            <el-option
                v-for="item in kidStatusList"
                :key="item.key"
                :value="item.key"
                :label="item.value"
            />
          </el-select>

          <!-- Chọn khối (chỉ hiện ở tab lớp) -->
          <el-select
              v-if="isClassTab"
              v-model="searchRequest.idGrade"
              placeholder="Chọn khối"
              class="mrv-filter-control mrv-filter-control--grade"
              @change="handleGradeChange"
          >
            <el-option
                v-for="item in gradeOfSchoolList"
                :key="item.id"
                :value="item.id"
                :label="item.gradeName"
            />
          </el-select>

          <!-- Chọn lớp (chỉ hiện ở tab lớp) -->
          <el-select
              v-if="isClassTab"
              v-model="searchRequest.idClass"
              placeholder="Chọn lớp"
              class="mrv-filter-control"
              @change="handleSearch"
          >
            <el-option
                v-for="item in classList"
                :key="item.id"
                :value="item.id"
                :label="item.className"
            />
          </el-select>

          <!-- Chọn nhóm (chỉ hiện ở tab nhóm) -->
          <el-select
              v-if="isGroupTab"
              v-model="searchRequest.idGroup"
              placeholder="Chọn nhóm"
              class="mrv-filter-control mrv-filter-control--group"
              @change="handleSearch"
          >
            <el-option
                v-for="item in kidGroupList"
                :key="item.id"
                :value="item.id"
                :label="item.nameGroup"
            />
          </el-select>

          <!-- Chọn gói (chỉ hiện ở tab gói) -->
          <el-select
              v-if="isPackageTab"
              v-model="searchRequest.idPackage"
              placeholder="Chọn gói"
              class="mrv-filter-control mrv-filter-control--group"
              @change="handleSearch"
          >
            <el-option
                v-for="item in packageDropdownList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
            />
          </el-select>

          <!-- Tìm kiếm theo tên -->
          <el-input
              v-model="searchRequest.fullName"
              placeholder="Nhập tên học sinh..."
              clearable
              class="mrv-search-input"
              @keyup.enter.native="handleSearch"
              @clear="handleSearch"
          >
            <template #append>
              <el-button icon="el-icon-search" @click="handleSearch" />
            </template>
          </el-input>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TABLE CARD: Bảng đăng ký khoản sử dụng
         ============================================================ -->
    <div class="mrv-table-card row-data">
      <!-- Header card -->
      <div class="mrv-card-head mrv-table-head">
        <div>
          <p class="mrv-card-title">Đăng ký khoản sử dụng</p>
          <p class="mrv-card-subtitle">
            Kích hoạt / hủy kích hoạt khoản thu cho từng học sinh theo lớp hoặc nhóm.
          </p>
        </div>
      </div>

      <!-- Tabs -->
      <el-tabs
          v-model="activeTab"
          type="card"
          class="sk-tabs"
          @tab-click="handleTabChange"
      >
        <!-- ===== Tab 1: Đăng ký theo lớp ===== -->
        <el-tab-pane name="CLASS_REGISTER">
          <template slot="label">
            <i class="el-icon-s-check" /> Đăng ký theo lớp
          </template>

          <div class="mrv-table-wrapper">
            <el-table
                ref="tableClassRegisterRef"
                :data="tab1DataList"
                :empty-text="emptyText"
                v-loading="tableLoading"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255,0)"
                highlight-current-row
                class="sk-table"
                :max-height="$tableMaxHeight"
                border
                @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" align="center" width="50" />
              <el-table-column type="index" label="STT" width="55" align="center" fixed/>
              <el-table-column prop="fullName" label="Họ tên" min-width="170" fixed />
              <el-table-column label="Ngày sinh" align="center" width="120">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column label="Trạng thái" align="center" width="115">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="mini" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>

              <!-- Cột khoản thu động -->
              <el-table-column
                  v-for="pkg in tab1PackageList"
                  :key="pkg.id"
                  align="center"
                  min-width="130"
              >
                <template slot="header">
                  <el-popover placement="top" width="200" trigger="hover" :content="pkg.name">
                    <span slot="reference" class="mrv-col-name">{{ pkg.name }}</span>
                  </el-popover>
                  <br />
                  <el-checkbox
                      :value="getPackageCheckClass(pkg.id)"
                      @change="(val) => handleHeaderCheckClass(pkg.id, val)"
                  />
                </template>
                <template slot-scope="{ row }">
                  <el-checkbox
                      v-if="getPackageItem(row.fnKidsPackageList, pkg.id)"
                      :value="getPackageItem(row.fnKidsPackageList, pkg.id).active"
                      @change="(val) => setPackageActive(row, pkg.id, val)"
                  />
                </template>
              </el-table-column>

              <!-- Cột tác vụ -->
              <el-table-column label="Tác vụ" fixed="right" width="100" align="center">
                <template slot-scope="{ row }">
                  <el-button
                      type="success"
                      size="mini"
                      @click="handleSaveOne(row)"
                  >
                    Lưu
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <!-- ===== Tab 2: Chi tiết học sinh theo lớp ===== -->
        <el-tab-pane name="CLASS_DETAIL">
          <template slot="label">
            <i class="el-icon-tickets" /> Chi tiết theo lớp
          </template>

          <div class="mrv-table-wrapper">
            <el-table
                ref="tableClassDetailRef"
                :data="tab2DataList"
                :empty-text="emptyText"
                v-loading="tableLoading"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255,0)"
                :cell-style="rowStyleExpanded"
                class="sk-table"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column type="expand" width="1">
                <template slot-scope="{ row }">
                  <div class="mrv-expand-wrapper">
                    <el-table
                        :data="row.revenueManagementResponses"
                        :empty-text="emptyText"
                        :cell-style="rowStyleCategory"
                        border
                        class="sk-table mrv-inner-table"
                    >
                      <el-table-column type="index" label="STT" width="50" align="center" />
                      <el-table-column label="Tên khoản" prop="revenueName" min-width="160" />
                      <el-table-column label="Kích hoạt" align="center" width="90">
                        <template slot-scope="{ row: r }">
                          <i
                              :class="r.active ? 'el-icon-circle-check' : 'el-icon-close'"
                              :style="{ color: r.active ? '#16a34a' : '#dc2626', fontSize: '18px' }"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="Loại" align="center" width="85">
                        <template slot-scope="{ row: r }">
                          <el-tag :type="r.category === 'IN' ? 'success' : 'info'" size="mini" effect="light">
                            {{ r.category === 'IN' ? 'Thu' : 'Chi' }}
                          </el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="Công thức" width="105" align="center">
                        <template slot-scope="{ row: r }">
                          <el-tag v-if="r.hasFormula" type="warning" size="mini" effect="dark">
                            <i class="el-icon-s-operation" /> Có
                          </el-tag>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Biểu thức" min-width="140">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.hasFormula && r.formulaExpression" class="mrv-formula-badge">
                            {{ r.formulaExpression }}
                          </span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="SL" align="center" width="65">
                        <template slot-scope="{ row: r }">
                          {{ formatQuantity(r.quantity) }}
                        </template>
                      </el-table-column>
                      <el-table-column label="Đơn vị" prop="unit" align="center" width="90" />
                      <el-table-column label="Đơn giá" align="right" width="135">
                        <template slot-scope="{ row: r }">
                          <span class="mrv-money">{{ r.price | formatCurrency }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Giảm giá" align="center" width="80">
                        <template slot-scope="{ row: r }">
                          <i
                              :class="r.discount ? 'el-icon-circle-check' : 'el-icon-close'"
                              :style="{ color: r.discount ? '#16a34a' : '#dc2626', fontSize: '16px' }"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="Loại giảm" align="center" width="100">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.discountType === 'PERCENT'">%</span>
                          <span v-else-if="r.discountType === 'MONEY'">VNĐ</span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Giá trị giảm" align="right" width="120">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.discount && r.discountType === 'MONEY'" class="mrv-money">
                            {{ r.discountNumber | formatCurrency }}
                          </span>
                          <span v-else-if="r.discount && r.discountType === 'PERCENT'" class="mrv-money">
                            {{ r.discountNumber }}%
                          </span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Tác vụ" width="80" align="center" fixed="right">
                        <template slot-scope="{ row: r }">
                          <el-tooltip content="Chỉnh sửa" placement="top">
                            <el-button
                                type="primary"
                                icon="el-icon-edit"
                                size="mini"
                                circle
                                plain
                                @click="openEditDetailDialog(r)"
                            />
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>

              <el-table-column type="index" label="STT" width="55" align="center" />
              <el-table-column prop="fullName" label="Họ tên" min-width="200" />
              <el-table-column label="Ngày sinh" align="center" width="120">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column label="Trạng thái" align="center" width="115">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="mini" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Số khoản" align="center" width="90">
                <template slot-scope="{ row }">
                  <span class="mrv-revenue-count">
                    {{ (row.revenueManagementResponses || []).length }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Tác vụ" width="110" align="center" fixed="right">
                <template slot-scope="{ row, $index }">
                  <span v-if="(row.revenueManagementResponses || []).length > 0">
                    <el-tooltip :content="row.expandRow ? 'Thu gọn' : 'Mở rộng'" placement="top">
                      <el-button
                          :type="row.expandRow ? 'warning' : 'primary'"
                          :icon="row.expandRow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                          size="mini"
                          circle
                          plain
                          @click="handleToggleExpandClass($index, row)"
                      />
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <!-- ===== Tab 3: Đăng ký theo nhóm ===== -->
        <el-tab-pane name="GROUP_REGISTER">
          <template slot="label">
            <i class="el-icon-s-check" /> Đăng ký theo nhóm
          </template>

          <div class="mrv-table-wrapper">
            <el-table
                ref="tableGroupRegisterRef"
                :data="tab3DataList"
                :empty-text="emptyText"
                v-loading="tableLoading"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255,0)"
                highlight-current-row
                class="sk-table"
                :max-height="$tableMaxHeight"
                border
                @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" align="center" width="50" />
              <el-table-column type="index" label="STT" width="55" align="center" fixed/>
              <el-table-column prop="fullName" label="Họ tên" min-width="170" fixed />
              <el-table-column label="Ngày sinh" align="center" width="120">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column label="Trạng thái" align="center" width="115">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="mini" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>

              <!-- Cột khoản thu động -->
              <el-table-column
                  v-for="pkg in tab3PackageList"
                  :key="pkg.id"
                  align="center"
                  min-width="130"
              >
                <template slot="header">
                  <el-popover placement="top" width="200" trigger="hover" :content="pkg.name">
                    <span slot="reference" class="mrv-col-name">{{ pkg.name }}</span>
                  </el-popover>
                  <br />
                  <el-checkbox
                      :value="getPackageCheckGroup(pkg.id)"
                      @change="(val) => handleHeaderCheckGroup(pkg.id, val)"
                  />
                </template>
                <template slot-scope="{ row }">
                  <el-checkbox
                      v-if="getPackageItem(row.fnKidsPackageList, pkg.id)"
                      :value="getPackageItem(row.fnKidsPackageList, pkg.id).active"
                      @change="(val) => setPackageActive(row, pkg.id, val)"
                  />
                </template>
              </el-table-column>

              <!-- Cột tác vụ -->
              <el-table-column label="Tác vụ" fixed="right" width="100" align="center">
                <template slot-scope="{ row }">
                  <el-button
                      type="success"
                      size="mini"
                      @click="handleSaveOne(row)"
                  >
                    Lưu
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <!-- ===== Tab 4: Chi tiết học sinh theo nhóm ===== -->
        <el-tab-pane name="GROUP_DETAIL">
          <template slot="label">
            <i class="el-icon-tickets" /> Chi tiết theo nhóm
          </template>

          <div class="mrv-table-wrapper">
            <el-table
                ref="tableGroupDetailRef"
                :data="tab4DataList"
                :empty-text="emptyText"
                v-loading="tableLoading"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255,0)"
                :cell-style="rowStyleExpanded"
                class="sk-table"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column type="expand" width="1">
                <template slot-scope="{ row }">
                  <div class="mrv-expand-wrapper">
                    <el-table
                        :data="row.revenueManagementResponses"
                        :empty-text="emptyText"
                        :cell-style="rowStyleCategory"
                        border
                        class="sk-table mrv-inner-table"
                    >
                      <el-table-column type="index" label="STT" width="50" align="center" />
                      <el-table-column label="Tên khoản" prop="revenueName" min-width="160" />
                      <el-table-column label="Kích hoạt" align="center" width="90">
                        <template slot-scope="{ row: r }">
                          <i
                              :class="r.active ? 'el-icon-circle-check' : 'el-icon-close'"
                              :style="{ color: r.active ? '#16a34a' : '#dc2626', fontSize: '18px' }"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="Loại" align="center" width="85">
                        <template slot-scope="{ row: r }">
                          <el-tag :type="r.category === 'IN' ? 'success' : 'info'" size="mini" effect="light">
                            {{ r.category === 'IN' ? 'Thu' : 'Chi' }}
                          </el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="Công thức" width="105" align="center">
                        <template slot-scope="{ row: r }">
                          <el-tag v-if="r.hasFormula" type="warning" size="mini" effect="dark">
                            <i class="el-icon-s-operation" /> Có
                          </el-tag>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Biểu thức" min-width="140">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.hasFormula && r.formulaExpression" class="mrv-formula-badge">
                            {{ r.formulaExpression }}
                          </span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="SL" align="center" width="65">
                        <template slot-scope="{ row: r }">
                          {{ formatQuantity(r.quantity) }}
                        </template>
                      </el-table-column>
                      <el-table-column label="Đơn vị" prop="unit" align="center" width="90" />
                      <el-table-column label="Đơn giá" align="right" width="135">
                        <template slot-scope="{ row: r }">
                          <span class="mrv-money">{{ r.price | formatCurrency }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Giảm giá" align="center" width="80">
                        <template slot-scope="{ row: r }">
                          <i
                              :class="r.discount ? 'el-icon-circle-check' : 'el-icon-close'"
                              :style="{ color: r.discount ? '#16a34a' : '#dc2626', fontSize: '16px' }"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="Loại giảm" align="center" width="100">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.discountType === 'PERCENT'">%</span>
                          <span v-else-if="r.discountType === 'MONEY'">VNĐ</span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Giá trị giảm" align="right" width="120">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.discount && r.discountType === 'MONEY'" class="mrv-money">
                            {{ r.discountNumber | formatCurrency }}
                          </span>
                          <span v-else-if="r.discount && r.discountType === 'PERCENT'" class="mrv-money">
                            {{ r.discountNumber }}%
                          </span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Tác vụ" width="80" align="center" fixed="right">
                        <template slot-scope="{ row: r }">
                          <el-tooltip content="Chỉnh sửa" placement="top">
                            <el-button
                                type="primary"
                                icon="el-icon-edit"
                                size="mini"
                                circle
                                plain
                                @click="openEditDetailDialog(r)"
                            />
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>

              <el-table-column type="index" label="STT" width="55" align="center" />
              <el-table-column prop="fullName" label="Họ tên" min-width="200" />
              <el-table-column label="Ngày sinh" align="center" width="120">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column label="Trạng thái" align="center" width="115">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="mini" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Số khoản" align="center" width="90">
                <template slot-scope="{ row }">
                  <span class="mrv-revenue-count">
                    {{ (row.revenueManagementResponses || []).length }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Tác vụ" width="110" align="center" fixed="right">
                <template slot-scope="{ row, $index }">
                  <span v-if="(row.revenueManagementResponses || []).length > 0">
                    <el-tooltip :content="row.expandRow ? 'Thu gọn' : 'Mở rộng'" placement="top">
                      <el-button
                          :type="row.expandRow ? 'warning' : 'primary'"
                          :icon="row.expandRow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                          size="mini"
                          circle
                          plain
                          @click="handleToggleExpandGroup($index, row)"
                      />
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <!-- ===== Tab 5: Đăng ký theo gói ===== -->
        <el-tab-pane name="PACKAGE_REGISTER">
          <template slot="label">
            <i class="el-icon-s-check" /> Đăng ký theo gói
          </template>

          <div class="mrv-table-wrapper">
            <el-table
                ref="tablePackageRegisterRef"
                :data="tab5DataList"
                :empty-text="emptyText"
                v-loading="tableLoading"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255,0)"
                highlight-current-row
                class="sk-table"
                :max-height="$tableMaxHeight"
                border
                @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" align="center" width="50" />
              <el-table-column type="index" label="STT" width="55" align="center" fixed/>
              <el-table-column prop="fullName" label="Họ tên" min-width="170" fixed />
              <el-table-column label="Ngày sinh" align="center" width="120">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column label="Trạng thái" align="center" width="115">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="mini" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>

              <!-- Cột khoản thu động -->
              <el-table-column
                  v-for="pkg in tab5PackageList"
                  :key="pkg.id"
                  align="center"
                  min-width="130"
              >
                <template slot="header">
                  <el-popover placement="top" width="200" trigger="hover" :content="pkg.name">
                    <span slot="reference" class="mrv-col-name">{{ pkg.name }}</span>
                  </el-popover>
                  <br />
                  <el-checkbox
                      :value="getPackageCheckPackage(pkg.id)"
                      @change="(val) => handleHeaderCheckPackage(pkg.id, val)"
                  />
                </template>
                <template slot-scope="{ row }">
                  <el-checkbox
                      v-if="getPackageItem(row.fnKidsPackageList, pkg.id)"
                      :value="getPackageItem(row.fnKidsPackageList, pkg.id).active"
                      @change="(val) => setPackageActive(row, pkg.id, val)"
                  />
                </template>
              </el-table-column>

              <!-- Cột tác vụ -->
              <el-table-column label="Tác vụ" fixed="right" width="100" align="center">
                <template slot-scope="{ row }">
                  <el-button
                      type="success"
                      size="mini"
                      @click="handleSaveOne(row)"
                  >
                    Lưu
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <!-- ===== Tab 6: Chi tiết học sinh theo gói ===== -->
        <el-tab-pane name="PACKAGE_DETAIL">
          <template slot="label">
            <i class="el-icon-tickets" /> Chi tiết theo gói
          </template>

          <div class="mrv-table-wrapper">
            <el-table
                ref="tablePackageDetailRef"
                :data="tab6DataList"
                :empty-text="emptyText"
                v-loading="tableLoading"
                :element-loading-text="$tableLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255,255,255,0)"
                :cell-style="rowStyleExpanded"
                class="sk-table"
                :max-height="$tableMaxHeight"
                border
            >
              <el-table-column type="expand" width="1">
                <template slot-scope="{ row }">
                  <div class="mrv-expand-wrapper">
                    <el-table
                        :data="row.revenueManagementResponses"
                        :empty-text="emptyText"
                        :cell-style="rowStyleCategory"
                        border
                        class="sk-table mrv-inner-table"
                    >
                      <el-table-column type="index" label="STT" width="50" align="center" />
                      <el-table-column label="Tên khoản" prop="revenueName" min-width="160" />
                      <el-table-column label="Kích hoạt" align="center" width="90">
                        <template slot-scope="{ row: r }">
                          <i
                              :class="r.active ? 'el-icon-circle-check' : 'el-icon-close'"
                              :style="{ color: r.active ? '#16a34a' : '#dc2626', fontSize: '18px' }"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="Loại" align="center" width="85">
                        <template slot-scope="{ row: r }">
                          <el-tag :type="r.category === 'IN' ? 'success' : 'info'" size="mini" effect="light">
                            {{ r.category === 'IN' ? 'Thu' : 'Chi' }}
                          </el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="Công thức" width="105" align="center">
                        <template slot-scope="{ row: r }">
                          <el-tag v-if="r.hasFormula" type="warning" size="mini" effect="dark">
                            <i class="el-icon-s-operation" /> Có
                          </el-tag>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Biểu thức" min-width="140">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.hasFormula && r.formulaExpression" class="mrv-formula-badge">
                            {{ r.formulaExpression }}
                          </span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="SL" align="center" width="65">
                        <template slot-scope="{ row: r }">
                          {{ formatQuantity(r.quantity) }}
                        </template>
                      </el-table-column>
                      <el-table-column label="Đơn vị" prop="unit" align="center" width="90" />
                      <el-table-column label="Đơn giá" align="right" width="135">
                        <template slot-scope="{ row: r }">
                          <span class="mrv-money">{{ r.price | formatCurrency }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Giảm giá" align="center" width="80">
                        <template slot-scope="{ row: r }">
                          <i
                              :class="r.discount ? 'el-icon-circle-check' : 'el-icon-close'"
                              :style="{ color: r.discount ? '#16a34a' : '#dc2626', fontSize: '16px' }"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="Loại giảm" align="center" width="100">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.discountType === 'PERCENT'">%</span>
                          <span v-else-if="r.discountType === 'MONEY'">VNĐ</span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Giá trị giảm" align="right" width="120">
                        <template slot-scope="{ row: r }">
                          <span v-if="r.discount && r.discountType === 'MONEY'" class="mrv-money">
                            {{ r.discountNumber | formatCurrency }}
                          </span>
                          <span v-else-if="r.discount && r.discountType === 'PERCENT'" class="mrv-money">
                            {{ r.discountNumber }}%
                          </span>
                          <span v-else class="mrv-text-muted">—</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Tác vụ" width="80" align="center" fixed="right">
                        <template slot-scope="{ row: r }">
                          <el-tooltip content="Chỉnh sửa" placement="top">
                            <el-button
                                type="primary"
                                icon="el-icon-edit"
                                size="mini"
                                circle
                                plain
                                @click="openEditDetailDialog(r)"
                            />
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>

              <el-table-column type="index" label="STT" width="55" align="center" />
              <el-table-column prop="fullName" label="Họ tên" min-width="200" />
              <el-table-column label="Ngày sinh" align="center" width="120">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column label="Trạng thái" align="center" width="115">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="mini" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Số khoản" align="center" width="90">
                <template slot-scope="{ row }">
                  <span class="mrv-revenue-count">
                    {{ (row.revenueManagementResponses || []).length }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Tác vụ" width="110" align="center" fixed="right">
                <template slot-scope="{ row, $index }">
                  <span v-if="(row.revenueManagementResponses || []).length > 0">
                    <el-tooltip :content="row.expandRow ? 'Thu gọn' : 'Mở rộng'" placement="top">
                      <el-button
                          :type="row.expandRow ? 'warning' : 'primary'"
                          :icon="row.expandRow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                          size="mini"
                          circle
                          plain
                          @click="handleToggleExpandPackage($index, row)"
                      />
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
            <!-- Save selected button fixed bottom-left on table (shown only on register tabs) -->
            <div v-if="isRegisterTab" class="mrv-save-bottom">
              <el-button
                  type="success"
                  class="mrv-action-button mrv-action-button--bottom"
                  :loading="isSavingMany"
                  @click="handleSaveMany"
              >
                <i class="el-icon-check" />
                Lưu đã chọn
              </el-button>
            </div>
    </div>

    <!-- ============================================================
         Dialog sửa thông tin tài chính khoản thu (API 7)
         ============================================================ -->
    <edit-revenue-detail-dialog
      ref="editDetailDialog"
      @saved="refreshCurrentTab"
    />
  </div>
</template>

<script>
import { kidStatusList } from "@/constant/listCommon";
import { mapState } from "vuex";
import managingRevenueService from "@/services/tutition_v3/ManagingRevenueService";
import PackageManagementService from "@/services/tutition_v3/PackageManagementService";
import revenueManagementServiceV2 from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import EditRevenueDetailDialog from "@/components/tutition_v3/dialog/EditRevenueDetailDialog.vue";
import { formatQuantity as formatQuantityValue } from "@/components/tutition_v3/utils/quantity";

const KID_STATUS_LABEL = {
  STUDYING:     "Đang học",
  RESERVE:      "Bảo lưu",
  LEAVE_SCHOOL: "Đã nghỉ",
  STUDY_WAIT:   "Chờ vào học",
};

const TAB = {
  CLASS_REGISTER: "CLASS_REGISTER",
  CLASS_DETAIL:   "CLASS_DETAIL",
  GROUP_REGISTER: "GROUP_REGISTER",
  GROUP_DETAIL:   "GROUP_DETAIL",
  PACKAGE_REGISTER: "PACKAGE_REGISTER",
  PACKAGE_DETAIL:   "PACKAGE_DETAIL",
};

export default {
  name: "ManagingRevenue",

  components: { EditRevenueDetailDialog },

  data() {
    return {
      tableLoading: false,
      isSavingMany:  false,
      emptyText:     "",
      activeTab:     TAB.CLASS_REGISTER,

      // Tab 1 – Đăng ký theo lớp
      tab1PackageList: [],
      tab1DataList:    [],

      // Tab 2 – Chi tiết học sinh theo lớp
      tab2DataList: [],

      // Tab 3 – Đăng ký theo nhóm
      tab3PackageList: [],
      tab3DataList:    [],

      // Tab 4 – Chi tiết học sinh theo nhóm
      tab4DataList: [],

      // Tab 5 – Đăng ký theo gói
      tab5PackageList: [],
      tab5DataList:    [],

      // Tab 6 – Chi tiết học sinh theo gói
      tab6DataList: [],

      packageDropdownList: [],


      multipleSelection: [],

      kidStatusList,
      kidGroupList: [],

      searchRequest: {
        status:   "STUDYING",
        idGrade:  "",
        idClass:  "",
        idGroup:  "",
        idPackage: "",
        fullName: "",
      },
    };
  },

  computed: {
    ...mapState("gradeModule", ["gradeOfSchoolList"]),
    ...mapState("classStore",  ["classListCommon"]),

    classList() {
      return this.classListCommon.filter(
          (x) => x.idGrade === this.searchRequest.idGrade
      );
    },

    isClassTab() {
      return this.activeTab === TAB.CLASS_REGISTER || this.activeTab === TAB.CLASS_DETAIL;
    },

    isGroupTab() {
      return this.activeTab === TAB.GROUP_REGISTER || this.activeTab === TAB.GROUP_DETAIL;
    },

    isPackageTab() {
      return this.activeTab === TAB.PACKAGE_REGISTER || this.activeTab === TAB.PACKAGE_DETAIL;
    },

    isRegisterTab() {
      return this.activeTab === TAB.CLASS_REGISTER || this.activeTab === TAB.GROUP_REGISTER || this.activeTab === TAB.PACKAGE_REGISTER;
    },
  },

  created() {
    this.$store.dispatch("gradeModule/fetchDataGradeOfSchoolList");
    this.$store.dispatch("classStore/fetchDataClassListCommon");
    this.fetchGroups();
    this.fetchPackages();
  },

  watch: {
    gradeOfSchoolList: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.searchRequest.idGrade = newVal[0].id;
        }
      },
    },
    classList: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.searchRequest.idClass = newVal[0].id;
          this.handleSearch();
        }
      },
    },
  },

  methods: {
    /* ─── Helpers ─────────────────────────────────────── */
    kidStatusLabel(status) {
      return KID_STATUS_LABEL[status] || status || "";
    },

    formatQuantity(value) {
      return formatQuantityValue(value);
    },

    kidStatusTagType(status) {
      const map = {
        STUDYING:     "success",
        RESERVE:      "warning",
        LEAVE_SCHOOL: "danger",
        STUDY_WAIT:   "info",
      };
      return map[status] || "";
    },

    getPackageItem(fnKidsPackageList, pkgId) {
      return (fnKidsPackageList || []).find((x) => x.id === pkgId) || null;
    },

    setPackageActive(row, pkgId, val) {
      const item = this.getPackageItem(row.fnKidsPackageList, pkgId);
      if (item) {
        this.$set(item, 'active', val);
        this.updateHeaderCheck(pkgId);
      }
    },

    isColAllChecked(pkgId, dataList) {
      if (!dataList || dataList.length === 0) return false;
      let hasPackageCount = 0;
      let checkedCount = 0;
      dataList.forEach((student) => {
        const item = this.getPackageItem(student.fnKidsPackageList, pkgId);
        if (item) {
          hasPackageCount++;
          if (item.active) checkedCount++;
        }
      });
      if (hasPackageCount === 0) return false;
      return hasPackageCount === checkedCount;
    },

    updateHeaderCheck(pkgId) {
      if (this.activeTab === TAB.CLASS_REGISTER) {
        const pkgIndex = this.tab1PackageList.findIndex((p) => p.id === pkgId);
        if (pkgIndex !== -1) {
          const pkg = this.tab1PackageList[pkgIndex];
          pkg.check = this.isColAllChecked(pkgId, this.tab1DataList);
          this.$set(this.tab1PackageList, pkgIndex, { ...pkg });
        }
      } else if (this.activeTab === TAB.PACKAGE_REGISTER) {
        const pkgIndex = this.tab5PackageList.findIndex((p) => p.id === pkgId);
        if (pkgIndex !== -1) {
          const pkg = this.tab5PackageList[pkgIndex];
          pkg.check = this.isColAllChecked(pkgId, this.tab5DataList);
          this.$set(this.tab5PackageList, pkgIndex, { ...pkg });
        }
      } else if (this.activeTab === TAB.GROUP_REGISTER) {
        const pkgIndex = this.tab3PackageList.findIndex((p) => p.id === pkgId);
        if (pkgIndex !== -1) {
          const pkg = this.tab3PackageList[pkgIndex];
          pkg.check = this.isColAllChecked(pkgId, this.tab3DataList);
          this.$set(this.tab3PackageList, pkgIndex, { ...pkg });
        }
      }
    },

    getPackageCheckClass(pkgId) {
      const pkg = this.tab1PackageList.find((p) => p.id === pkgId);
      return pkg ? pkg.check : false;
    },

    getPackageCheckGroup(pkgId) {
      const pkg = this.tab3PackageList.find((p) => p.id === pkgId);
      return pkg ? pkg.check : false;
    },

    getPackageCheckPackage(pkgId) {
      const pkg = this.tab5PackageList.find((p) => p.id === pkgId);
      return pkg ? pkg.check : false;
    },

    rowStyleExpanded({ row }) {
      if (row.expandRow) return "font-weight: 700;";
    },

    rowStyleCategory({ row }) {
      if (row.category === "OUT") return "color: #2563eb;";
    },

    /* ─── Tab ─────────────────────────────────────────── */
    handleTabChange(tab) {
      const name = tab.name;
      this.multipleSelection = [];
      if (name === TAB.CLASS_REGISTER) this.fetchClassRegister();
      else if (name === TAB.CLASS_DETAIL)   this.fetchClassDetail();
      else if (name === TAB.GROUP_REGISTER) this.fetchGroupRegister();
      else if (name === TAB.GROUP_DETAIL)   this.fetchGroupDetail();
      else if (name === TAB.PACKAGE_REGISTER) this.fetchPackageRegister();
      else if (name === TAB.PACKAGE_DETAIL)   this.fetchPackageDetail();
    },

    /* ─── Filter ──────────────────────────────────────── */
    handleGradeChange() {
      if (this.classList.length > 0) {
        this.searchRequest.idClass = this.classList[0].id;
      }
      this.handleSearch();
    },

    handleSearch() {
      const t = this.activeTab;
      if (t === TAB.CLASS_REGISTER) this.fetchClassRegister();
      else if (t === TAB.CLASS_DETAIL)   this.fetchClassDetail();
      else if (t === TAB.GROUP_REGISTER) this.fetchGroupRegister();
      else if (name === TAB.GROUP_DETAIL)   this.fetchGroupDetail();
      else if (name === TAB.PACKAGE_REGISTER) this.fetchPackageRegister();
      else if (name === TAB.PACKAGE_DETAIL)   this.fetchPackageDetail();
    },

    /* ─── Selection ───────────────────────────────────── */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /* ─── Expand rows ─────────────────────────────────── */
    handleToggleExpandClass(index, row) {
      row.expandRow = !row.expandRow;
      this.$refs.tableClassDetailRef.toggleRowExpansion(row);
    },

    handleToggleExpandGroup(index, row) {
      row.expandRow = !row.expandRow;
      this.$refs.tableGroupDetailRef.toggleRowExpansion(row);
    },

    handleToggleExpandPackage(index, row) {
      row.expandRow = !row.expandRow;
      this.$refs.tablePackageDetailRef.toggleRowExpansion(row);
    },

    /* ─── Header checkbox ─────────────────────────────── */
    handleHeaderCheckClass(pkgId, checked) {
      this.tab1DataList.forEach((student) => {
        const item = this.getPackageItem(student.fnKidsPackageList, pkgId);
        if (item) this.$set(item, 'active', checked);
      });
      this.updateHeaderCheck(pkgId);
    },

    handleHeaderCheckGroup(pkgId, checked) {
      this.tab3DataList.forEach((student) => {
        const item = this.getPackageItem(student.fnKidsPackageList, pkgId);
        if (item) this.$set(item, 'active', checked);
      });
      this.updateHeaderCheck(pkgId);
    },

    handleHeaderCheckPackage(pkgId, checked) {
      this.tab5DataList.forEach((student) => {
        const item = this.getPackageItem(student.fnKidsPackageList, pkgId);
        if (item) this.$set(item, 'active', checked);
      });
      this.updateHeaderCheck(pkgId);
    },

    /* ─── Save: 1 học sinh ────────────────────────────── */
    handleSaveOne(row) {
      const payload = {
        id:               row.id,
        fullName:         row.fullName,
        fnKidsPackageList: (row.fnKidsPackageList || []).map((item) => ({
          id:         item.id,
          targetId:   item.targetId,
          targetType: item.targetType,
          active:     item.active,
        })),
      };
      managingRevenueService.activeOne(payload)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Lưu thành công!");
            this.refreshCurrentTab();
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError(
                err?.response?.data?.message || "Lưu thất bại!"
            );
          });
    },

    /* ─── Save: nhiều học sinh ────────────────────────── */
    handleSaveMany() {
      const selected = this.multipleSelection;
      if (!selected || selected.length === 0) {
        NotifyMessage.leftCornerNotificationError("Chưa chọn học sinh nào!");
        return;
      }
      this.isSavingMany = true;
      const payload = selected.map((row) => ({
        id:               row.id,
        fullName:         row.fullName,
        fnKidsPackageList: (row.fnKidsPackageList || []).map((item) => ({
          id:         item.id,
          targetId:   item.targetId,
          targetType: item.targetType,
          active:     item.active,
        })),
      }));
      managingRevenueService.activeMany(payload)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Lưu thành công!");
            this.refreshCurrentTab();
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError(
                err?.response?.data?.message || "Lưu thất bại!"
            );
          })
          .finally(() => {
            setTimeout(() => { this.isSavingMany = false; }, 500);
          });
    },

    refreshCurrentTab() {
      const t = this.activeTab;
      if (t === TAB.CLASS_REGISTER) this.fetchClassRegister();
      else if (t === TAB.CLASS_DETAIL)   this.fetchClassDetail();
      else if (t === TAB.GROUP_REGISTER) this.fetchGroupRegister();
      else if (name === TAB.GROUP_DETAIL)   this.fetchGroupDetail();
      else if (name === TAB.PACKAGE_REGISTER) this.fetchPackageRegister();
      else if (name === TAB.PACKAGE_DETAIL)   this.fetchPackageDetail();
    },

    /* ─── Fetch: Tab 1 (init-search theo lớp) ─────────── */
    async fetchClassRegister() {
      if (!this.searchRequest.idClass) return;
      this.emptyText   = "";
      this.tableLoading = true;
      this.tab1PackageList = [];
      this.tab1DataList    = [];
      try {
        const params = this._buildParams({ idClass: this.searchRequest.idClass });
        const res  = await managingRevenueService.initSearchByClass(params);
        const data = res.data.data;
        this.tab1DataList    = JSON.parse(JSON.stringify(data.dataList || []));
        this.tab1PackageList = (data.packageList || []).map(pkg => ({
          ...pkg,
          check: this.isColAllChecked(pkg.id, this.tab1DataList)
        }));
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Lỗi tải dữ liệu!"
        );
      } finally {
        if (!this.tab1DataList.length) this.emptyText = this.$tableEmpty;
        setTimeout(() => { this.tableLoading = false; }, 300);
      }
    },

    /* ─── Fetch: Tab 2 (details theo lớp) ─────────────── */
    async fetchClassDetail() {
      if (!this.searchRequest.idClass) return;
      this.emptyText   = "";
      this.tableLoading = true;
      this.tab2DataList = [];
      try {
        const params = this._buildParams({ idClass: this.searchRequest.idClass });
        const res  = await managingRevenueService.getClassDetails(params);
        this.tab2DataList = (res.data.data || []).map((r) => ({ ...r, expandRow: false }));
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Lỗi tải dữ liệu!"
        );
      } finally {
        if (!this.tab2DataList.length) this.emptyText = this.$tableEmpty;
        setTimeout(() => { this.tableLoading = false; }, 300);
      }
    },

    /* ─── Fetch: Tab 3 (init-search theo nhóm) ─────────── */
    async fetchGroupRegister() {
      if (!this.searchRequest.idGroup) { this.tableLoading = false; return; }
      this.emptyText   = "";
      this.tableLoading = true;
      this.tab3PackageList = [];
      this.tab3DataList    = [];
      try {
        const params = this._buildParams({ idGroup: this.searchRequest.idGroup });
        const res  = await managingRevenueService.initSearchByGroup(params);
        const data = res.data.data;
        this.tab3DataList    = JSON.parse(JSON.stringify(data.dataList || []));
        this.tab3PackageList = (data.packageList || []).map(pkg => ({
          ...pkg,
          check: this.isColAllChecked(pkg.id, this.tab3DataList)
        }));
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Lỗi tải dữ liệu!"
        );
      } finally {
        if (!this.tab3DataList.length) this.emptyText = this.$tableEmpty;
        setTimeout(() => { this.tableLoading = false; }, 300);
      }
    },

    /* ─── Fetch: Tab 4 (details theo nhóm) ─────────────── */
    async fetchGroupDetail() {
      if (!this.searchRequest.idGroup) { this.tableLoading = false; return; }
      this.emptyText   = "";
      this.tableLoading = true;
      this.tab4DataList = [];
      try {
        const params = this._buildParams({ idGroup: this.searchRequest.idGroup });
        const res  = await managingRevenueService.getGroupDetails(params);
        this.tab4DataList = (res.data.data || []).map((r) => ({ ...r, expandRow: false }));
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Lỗi tải dữ liệu!"
        );
      } finally {
        if (!this.tab4DataList.length) this.emptyText = this.$tableEmpty;
        setTimeout(() => { this.tableLoading = false; }, 300);
      }
    },

    /* ─── Fetch: Tab 5 (init-search theo gói) ─────────── */
    async fetchPackageRegister() {
      if (!this.searchRequest.idPackage) { this.tableLoading = false; return; }
      this.emptyText   = "";
      this.tableLoading = true;
      this.tab5PackageList = [];
      this.tab5DataList    = [];
      try {
        const params = this._buildParams({ idPackage: this.searchRequest.idPackage });
        const res  = await managingRevenueService.initSearchByPackage(params);
        const data = res.data.data;
        this.tab5DataList    = JSON.parse(JSON.stringify(data.dataList || []));
        this.tab5PackageList = (data.packageList || []).map(pkg => ({
          ...pkg,
          check: this.isColAllChecked(pkg.id, this.tab5DataList)
        }));
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Lỗi tải dữ liệu!"
        );
      } finally {
        if (!this.tab5DataList.length) this.emptyText = this.$tableEmpty;
        setTimeout(() => { this.tableLoading = false; }, 300);
      }
    },

    /* ─── Fetch: Tab 6 (details theo gói) ─────────────── */
    async fetchPackageDetail() {
      if (!this.searchRequest.idPackage) { this.tableLoading = false; return; }
      this.emptyText   = "";
      this.tableLoading = true;
      this.tab6DataList = [];
      try {
        const params = this._buildParams({ idPackage: this.searchRequest.idPackage });
        const res  = await managingRevenueService.getPackageDetails(params);
        this.tab6DataList = (res.data.data || []).map((r) => ({ ...r, expandRow: false }));
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Lỗi tải dữ liệu!"
        );
      } finally {
        if (!this.tab6DataList.length) this.emptyText = this.$tableEmpty;
        setTimeout(() => { this.tableLoading = false; }, 300);
      }
    },

    fetchPackages() {
      PackageManagementService.search({ page: 0, size: 999 })
          .then((res) => {
            this.packageDropdownList = res.data.data || [];
            if (this.packageDropdownList.length > 0) {
              this.searchRequest.idPackage = this.packageDropdownList[0].id;
            }
          })
          .catch(() => {
            NotifyMessage.leftCornerNotificationError("Lỗi tải danh sách gói!");
          });
    },

    /* ─── Build params (loại bỏ key rỗng / null) ───────── */
    _buildParams(extra = {}) {
      const raw = {
        status:   this.searchRequest.status   || null,
        fullName: this.searchRequest.fullName || null,
        idPackage: this.searchRequest.idPackage || null,
        ...extra,
      };
      Object.keys(raw).forEach((k) => {
        if (raw[k] === "" || raw[k] === null || raw[k] === undefined) delete raw[k];
      });
      return raw;
    },

    /* ─── Load groups ─────────────────────────────────── */
    fetchGroups() {
      revenueManagementServiceV2.getListKidsGroup()
          .then((res) => {
            this.kidGroupList = res.data || [];
            if (this.kidGroupList.length > 0) {
              this.searchRequest.idGroup = this.kidGroupList[0].id;
            }
          })
          .catch(() => {
            NotifyMessage.leftCornerNotificationError("Lỗi tải danh sách nhóm!");
          });
    },

    /* ─── Action on expanding rows ─────────────────────── */
    async openEditDetailDialog(row) {
      try {
        const res = await managingRevenueService.getDetailById(row.id);
        const detail = res?.data?.data || row;
        this.$refs.editDetailDialog.open(detail);
      } catch {
        this.$refs.editDetailDialog.open(row);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

/* =====================================================
   ManagingRevenue – Prefix: mrv-
   ===================================================== */

.mrv-page {
  padding: 4px 0 16px;
  .row-data { margin-bottom: 20px; }
}

/* ─── Toolbar card ─────────────────────────────────── */
.mrv-toolbar-card {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.mrv-toolbar-section        { min-width: 0; }
.mrv-toolbar-section--filter { flex: 1; }

/* ─── Table card ───────────────────────────────────── */
.mrv-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 18px 18px 14px;
  position: relative; /* allow absolute-positioned save button */
}

/* ─── Card head ────────────────────────────────────── */
.mrv-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}
.mrv-table-head { align-items: center; }

.mrv-card-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}
.mrv-card-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #64748b;
}

/* ─── Bộ lọc ──────────────────────────────────────── */
.mrv-filter-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.mrv-filter-control          { width: 155px; }
.mrv-filter-control--grade   { width: 130px; }
.mrv-filter-control--group   { width: 220px; }
.mrv-search-input            { width: 260px; }

/* ─── Action button ────────────────────────────────── */
.mrv-action-button {
  min-width: 140px;
  font-weight: 600;
}

/* Bottom-left save button */
.mrv-save-bottom {
  position: absolute;
  right: 0;
  bottom: -50px;
  z-index: 30;
}
.mrv-action-button--bottom {
  min-width: 160px;
}

/* ─── Table wrapper ────────────────────────────────── */
.mrv-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

/* ─── Inner table (expand row) ─────────────────────── */
.mrv-expand-wrapper {
  padding: 10px 16px 14px;
  background: #f8fafc;
}
.mrv-inner-table {
  border-radius: 10px;
  overflow: hidden;
}

/* ─── Tiền tệ & Text ───────────────────────────────── */
.mrv-money {
  font-variant-numeric: tabular-nums;
  color: #475569;
  font-size: 13px;
}
.mrv-text-muted { color: #94a3b8; font-size: 13px; }

/* ─── Tên cột khoản thu (truncate) ────────────────── */
.mrv-col-name {
  display: inline-block;
  max-width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-size: 12px;
}

.mrv-formula-badge {
  display: inline-block;
  padding: 2px 8px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 4px;
  font-size: 12px;
  font-family: monospace;
  color: #92400e;
  word-break: break-all;
}

/* Badge số khoản đăng ký */
.mrv-revenue-count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #eff6ff;
  color: #2563eb;
  font-weight: 700;
  font-size: 13px;
  padding: 3px 12px;
  border-radius: 20px;
  border: 1px solid #bfdbfe;

  i { font-size: 13px; }
}

/* ─── Tiêu đề bảng: nền xanh primary ─────────────── */
/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important;
  color: #ffffff !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead tr { height: 56px; }
/deep/ .sk-table tbody td { background: #ffffff; }

/* Inner table header: xanh nhạt hơn */
/deep/ .mrv-inner-table thead th,
/deep/ .mrv-inner-table thead td {
  background: #dbeafe !important;
  color: #1e40af !important;
  font-weight: 600;
}
/deep/ .mrv-inner-table thead th > .cell,
/deep/ .mrv-inner-table thead td > .cell {
  color: #1e40af !important;
}
/deep/ .mrv-inner-table tbody td { background: #f8fafc; }

/* ─── sk-tabs: màu tab theo guidelines ────────────── */
/deep/ .sk-tabs .el-tabs__nav {
  background: transparent;
  border: none;
}
/deep/ .sk-tabs .el-tabs__nav-wrap::after {
  background: #2563eb;
  height: 2px;
}
/deep/ .sk-tabs .el-tabs__item {
  background: #e5e7eb;
  color: #4b5563;
  font-weight: 600;
  border: 1px solid #d1d5db !important;
  border-bottom: none !important;
  border-radius: 8px 8px 0 0;
  transition: background 0.15s, color 0.15s;
  i { margin-right: 6px; }
}
/deep/ .sk-tabs .el-tabs__item:hover:not(.is-active) {
  background: #d1d5db;
  color: #1e293b;
}
/deep/ .sk-tabs .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2563eb !important;
  border-color: #2563eb !important;
}
/deep/ .sk-tabs .el-tabs__nav-scroll { float: right; }
/deep/ .sk-tabs .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none;
}
/deep/ .sk-tabs.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #2563eb;
}
/deep/ .sk-tabs.el-tabs--card > .el-tabs__header { border-bottom: none; }

/* ─── Checkbox header: màu trắng khi tab active ────── */
/deep/ .sk-tabs .el-tabs__item.is-active .el-checkbox__inner { border-color: #ffffff; }

/* ─── Input / Button bo góc ──────────────────────── */
/deep/ .mrv-page .el-input__inner,
/deep/ .mrv-page .el-select .el-input__inner { border-radius: 10px; }
/deep/ .mrv-page .el-button              { border-radius: 10px; }
/deep/ .mrv-page .el-input-group__append .el-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* ─── Responsive ──────────────────────────────────── */
@media (max-width: 1200px) {
  .mrv-toolbar-card { flex-direction: column; align-items: stretch; }
  .mrv-table-head   { flex-direction: column; align-items: flex-start; gap: 8px; }
}

@media (max-width: 768px) {
  .mrv-filter-grid { flex-direction: column; align-items: stretch; }
  .mrv-filter-control,
  .mrv-filter-control--grade,
  .mrv-filter-control--group,
  .mrv-search-input,
  .mrv-action-button { width: 100%; }
}
</style>
